interface CeccaLogoProps {
  className?: string;
  textColor?: string;
}

const CeccaLogo = ({ className = "", textColor = "currentColor" }: CeccaLogoProps) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 53.36 42.05" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="cecca-gradient" x1="0" y1="21.03" x2="40.74" y2="21.03" gradientUnits="userSpaceOnUse">
          <stop offset=".17" stopColor="#828282"/>
          <stop offset=".42" stopColor="#babbb9"/>
          <stop offset=".6" stopColor="#dcdedc"/>
          <stop offset=".7" stopColor="#eaece9"/>
        </linearGradient>
        <linearGradient id="cecca-gradient-2" x1="5.01" y1="21.05" x2="35.3" y2="21.05" xlinkHref="#cecca-gradient"/>
        <linearGradient id="cecca-gradient-3" x1="10.09" y1="21.05" x2="29.12" y2="21.05" xlinkHref="#cecca-gradient"/>
      </defs>
      <g>
        {/* Circular gradient rings */}
        <g>
          <path 
            d="M20.97,42.05h-.09c-1.94,0-3.88-.22-5.73-.8C4.16,37.81-2.51,26.45.89,15.08,4.54,2.94,18.37-3.61,30.07,2.07l-1.79,3.06c-8.91-4-19.2.05-23.16,8.78-3.93,8.71-.05,18.95,8.62,22.96,8.65,3.99,18.99.4,23.19-8.39l3.81-.04c-1.6,4.53-4.52,7.89-8.45,10.34-1.74,1.44-3.89,2.03-6.03,2.59-1.72.44-3.49.67-5.27.67Z" 
            fill="url(#cecca-gradient)"
          />
          <path 
            d="M25.84,9.46c-6.06-2.41-12.86.13-15.83,5.78-3.04,5.75-1.11,12.82,4.31,16.3,5.51,3.51,12.82,2.3,16.82-3.06h4.16c-4.09,7.85-13.61,10.77-21.36,6.93-7.72-3.84-11.1-13.14-7.48-21,3.61-7.88,12.87-11.61,21.17-8.04l-1.79,3.1Z" 
            fill="url(#cecca-gradient-2)"
          />
          <path 
            d="M23.26,13.92c-4.56-1.25-8.8,1.61-9.53,6-.65,4.3,2.54,8.37,7.09,8.55l8.3.02c-3.8,4.24-10.03,4.57-14.37,1.53-4.55-3.22-5.93-9.23-3.4-14.08,2.59-4.84,8.29-7.14,13.68-5.15l-1.76,3.13Z" 
            fill="url(#cecca-gradient-3)"
          />
        </g>
        {/* CECCA text - dynamic color */}
        <g fill={textColor}>
          <path d="M25.5,15.23h4.79v2.21h-1.92v2.09h1.79v2.1h-1.79v2.43h2.11v2.21h-4.98v-11.03Z"/>
          <path d="M38,19.38h-2.87v-1.26c0-.56-.03-.91-.09-1.04-.06-.14-.2-.21-.41-.21-.24,0-.39.08-.45.25-.06.17-.09.53-.09,1.09v5.13c0,.54.03.89.09,1.05.06.16.21.25.43.25s.35-.08.42-.25c.07-.16.1-.55.1-1.15v-.9h2.87v-.05c0,1.14-.08,1.95-.24,2.43s-.52.9-1.07,1.26c-.55.36-1.23.54-2.04.54s-1.53-.15-2.08-.46c-.54-.3-.91-.73-1.08-1.26-.18-.54-.27-1.35-.27-2.43v-3.22c0-.79.03-1.39.08-1.79s.22-.78.49-1.15.65-.66,1.12-.87,1.03-.32,1.65-.32c.85,0,1.54.16,2.09.49s.91.73,1.08,1.22c.17.49.26,1.25.26,2.28v.39Z"/>
          <path d="M51.72,15.23l1.64,11.03h-2.93l-.15-1.98h-1.03l-.17,1.98h-2.97l1.46-11.03h4.15ZM50.2,22.33c-.15-1.25-.29-2.79-.44-4.63-.29,2.11-.48,3.66-.55,4.63h.99Z"/>
          <path d="M45.7,19.38h-2.87v-1.26c0-.56-.03-.91-.09-1.04-.06-.14-.2-.21-.41-.21-.24,0-.39.08-.45.25-.06.17-.09.53-.09,1.09v5.13c0,.54.03.89.09,1.05.06.16.21.25.43.25s.35-.08.42-.25c.07-.16.1-.55.1-1.15v-.9h2.87v-.05c0,1.14-.08,1.95-.24,2.43s-.52.9-1.07,1.26c-.55.36-1.23.54-2.04.54s-1.53-.15-2.08-.46c-.54-.3-.91-.73-1.08-1.26-.18-.54-.27-1.35-.27-2.43v-3.22c0-.79.03-1.39.08-1.79s.22-.78.49-1.15.65-.66,1.12-.87,1.03-.32,1.65-.32c.85,0,1.54.16,2.09.49s.91.73,1.08,1.22c.17.49.26,1.25.26,2.28v.39Z"/>
          <path d="M24.57,19.38h-2.87v-1.26c0-.56-.03-.91-.09-1.04-.06-.14-.2-.21-.41-.21-.24,0-.39.08-.45.25-.06.17-.09.53-.09,1.09v5.13c0,.54.03.89.09,1.05.06.16.21.25.43.25s.35-.08.42-.25c.07-.16.1-.55.1-1.15v-.9h2.87v-.05c0,1.14-.08,1.95-.24,2.43s-.52.9-1.07,1.26c-.55.36-1.23.54-2.04.54s-1.53-.15-2.08-.46c-.54-.3-.91-.73-1.08-1.26-.18-.54-.27-1.35-.27-2.43v-3.22c0-.79.03-1.39.08-1.79s.22-.78.49-1.15.65-.66,1.12-.87,1.03-.32,1.65-.32c.85,0,1.54.16,2.09.49s.91.73,1.08,1.22c.17.49.26,1.25.26,2.28v.39Z"/>
        </g>
      </g>
    </svg>
  );
};

export default CeccaLogo;
